<template>
    <v-expansion-panel>
        <v-expansion-panel-header>
            <div>
                <v-icon v-show="this.errors.length >0"
                        class="mr-3"
                        color="error">
                    mdi-alert-box
                </v-icon>
                <v-icon class="mr-3">
                    {{ isActive ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                </v-icon>
                {{ language | languageKeyToName }}
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-switch :input-value="isActive"
                      :label="isActive ? 'Sprache aktiviert':'Sprache deaktiviert'"
                      @change="updateValue('isActive', $event)"
                      :readonly="readonly"/>
            <v-text-field label="Titel"
                          :value="title"
                          @input="updateValue('title', $event)"
                          :readonly="readonly"
                          :error="elementHasError('Title')"/>
            <v-textarea label="Nachricht"
                        :value="content"
                        @input="updateValue('content', $event)"
                        :readonly="readonly"
                        :error="elementHasError('Content')"/>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import languageKeyToName from "../../../utils/languageKeyToName";

export default {
    name: "NotificationExpansionPanel",
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        language: String,
        value: {
            type: Object,
            default: null,
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    filters: {
        languageKeyToName
    },
    data() {
        return {};
    },
    computed: {
        isActive() {
            return this.value !== null
                && this.value.title !== ''
                && this.value.content !== '';
        },
        title() {
            if (!this.value)
                return "";
            return this.value.title;
        },
        content() {
            if (!this.value)
                return "";
            return this.value.content;
        }
    },
    methods: {
        elementHasError(element) {
            return this.errors.find(error => error.subElement === element) !== undefined;
        },
        updateValue(property, value) {

            let updateValues = {
                [property]: value
            };
            if (property === 'title' || property === 'content') {
                updateValues.isActive = true;
            }

            this.$emit('change', Object.assign({}, this.value, updateValues));
        }
    },
}
</script>

<style scoped>

</style>
